import styled from '../../theme/styled-with-theme';
import { mediaQueries } from '../../styles/media-queries';
import { Text } from '../Text';

const BUFFER_WIDTH = '20px';

export const MobileVersion = styled('div')`
  display: block;

  ${mediaQueries.tablet} {
    display: none;
  }
`;

export const DesktopVersion = styled('div')`
  display: none;

  ${mediaQueries.tablet} {
    display: block;
  }
`;

export const Table = styled('table')`
  width: 100%;
  border-collapse: collapse;
`;

export const TableTitle = styled('th')`
  width: ${({ theme }) => theme.spacing['3xl']};
  padding-bottom: ${({ theme }) => theme.spacing.sm};
`;

export const TableHead = styled('th')<{ color: string }>`
  background-color: ${({ color }) => `${color}`};
  vertical-align: bottom;
  border-radius: ${({ theme }) =>
    `${theme.borderRadius.planHeaderDesktop} ${theme.borderRadius.planHeaderDesktop} 0 0`};
  padding: ${({ theme }) =>
    `${theme.spacing.l} ${theme.spacing.xs} ${theme.spacing.ml}`};
  width: ${({ theme }) => theme.spacing.sm};

  ${mediaQueries.desktop} {
    padding: ${({ theme }) =>
      `${theme.spacing.l} ${theme.spacing.ml} ${theme.spacing.ml}`};
  }
`;

export const PlanText = styled(Text)<{ color: string }>`
  color: ${({ color }) => color};
`;

export const FeatureRow = styled('tr')`
  border-top: 2px solid rgba(0, 0, 0, 0.1);
`;

export const BufferCell = styled('td')`
  width: ${BUFFER_WIDTH};
`;

export const FeatureCell = styled('td')`
  padding: ${({ theme }) => `${theme.spacing.ml} 0`};
`;

export const Checkmark = styled('td')<{
  color: string;
  lastFeatureInPlan: boolean;
}>`
  background-color: ${({ color }) => `${color}`};
  border-radius: ${({ theme, lastFeatureInPlan }) =>
    lastFeatureInPlan
      ? `0 0 ${theme.borderRadius.planHeaderDesktop} ${theme.borderRadius.planHeaderDesktop}`
      : '0'};
  padding: 35px 0;
  padding: ${({ theme }) => `${theme.spacing.l} 0`};
  text-align: center;
`;
